import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BoxShadow } from '@r1-frontend/ui-react/tokens/boxShadow';

export const Internet = styled.div`
    padding: 0;
    margin: 0;
    display: block;
    overflow-y: auto;
    scroll-behavior: smooth;
    width: 100%;
    height: 100vh;
    position: fixed;
    margin-top: 32px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 0;
    }

    & > section {
        &:nth-child(2) {
            @media (max-width: ${wideBreakpoints.mobile}) {
                padding-top: 52px;
            }
        }

        &:first-child {
            justify-content: center;
        }

        &:last-child {
            overflow: auto;
            overflow-x: hidden;
        }

        box-shadow: ${BoxShadow.L};
        position: sticky;
        overflow: hidden;
    }
`;
